const SubMenu = function() {
  this.menuKey = null;
  this.subMenuItems = [];
};
export default SubMenu;
